module.exports = __webpack_public_path__ + "mobile/img/hot-img1.44b9c541.png";